import Vue from 'vue'
import Vuex from 'vuex'

//Modules
import auth from '@/store/modules/auth'
import user from '@/store/modules/user'
import competencia from '@/store/modules/competencia'
import empresa from '@/store/modules/empresa'
import cliente from '@/store/modules/cliente'
import chat from '@/store/modules/chat'
import finanRelatorio from '@/store/modules/financeiro/relatorios'
import carteira from '@/store/modules/carteira'
import empresas from '@/store/modules/empresa/empresas'
import simulador from './modules/financeiro/simulador'
import configEmpresa from './modules/empresa/configEmpresa'
import financeiro from './modules/financeiro/financeiro';
import linker from './modules/empresa/linker'
import activityLogs from './modules/empresa/activityLogs'
import atividades from './modules/empresa/atividades'
import etapas from './modules/empresa/etapas'
import motivoRetencao from './modules/empresa/motivoRetencao'
import retencao from './modules/empresa/retencao'
import indicacao from './modules/empresa/indicacao'
import texto from './modules/empresa/texto'
import configcoretapas from './modules/empresa/configcoretapas' 
import pasta from './modules/empresa/pasta'
import tabela from './modules/empresa/tabela'
import planilhaContabilidade from './modules/empresa/planilhaContabilidade'
import etapasEmpresa from './modules/empresa/etapasEmpresa'
import tomador from './modules/empresa/tomador'
import enf from './modules/empresa/enf'
import controleIrpf from './modules/empresa/controleIrpf'
import atividadesCompetencia from './modules/atividades/atividadesCompetencia'
import dctfweb from './modules/atividades/dctfweb'
import guiaDataVencimentoPadrao from './modules/empresa/guiaDataVencimentoPadrao'
import tipoAtividade from './modules/atividades/tipoAtividade'



Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    user,
    competencia,
    empresa,
    cliente,
    chat,
    finanRelatorio,
    carteira,
    empresas,
    simulador,
    configEmpresa,
    financeiro,
    linker,
    activityLogs,
    atividades,
    etapas,
    etapasEmpresa,
    retencao,
    motivoRetencao,
    indicacao,
    texto,
    configcoretapas,
    pasta,
    tabela,
    planilhaContabilidade,
    tomador,
    enf,
    controleIrpf,
    dctfweb,
    atividadesCompetencia,
    guiaDataVencimentoPadrao,
    tipoAtividade
  }
})

export default store